import React, { FC, PropsWithChildren } from "react";
import { DateTime } from "@/components/common/DateTime";
import { Button } from "@/components/ui/button";
import { ArrowDownFromLine } from "lucide-react";
import { useToggle } from "@/hooks/useToggle";
import { cn } from "@/lib/utils";

export const SettlementSummaryBar: FC<
  PropsWithChildren<{ contentClassName?: string }>
> = ({ children, contentClassName }) => {
  const { value: showStatCards, handleToggle } = useToggle(true);

  return (
    <div className="flex flex-col gap-2 rounded-lg bg-neutral-50 p-4">
      <div className="flex items-center justify-between">
        <DateTime
          className="flex-row justify-end gap-2"
          timeClassName="text-base text-stone font-semibold"
        />

        <Button variant="ghost" onClick={handleToggle}>
          <ArrowDownFromLine
            className={cn(
              "text-dark-gray size-4 transition-transform",
              !showStatCards && "rotate-180",
            )}
          />
        </Button>
      </div>

      {showStatCards && (
        <div className={cn("flex gap-4", contentClassName)}>{children}</div>
      )}
    </div>
  );
};
